"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.deepReplaceContent = exports.replaceContent = void 0;
/** @deprecated use `@genoa/screen-content` for this utility and screen-content */
var replaceContent = function (inputString, replacements) {
    if (!inputString) {
        return '';
    }
    return inputString.replace(/{{([^{}]+)}}/g, function (_, key) {
        var replacement = replacements[key.trim()];
        return replacement !== undefined ? replacement : '';
    });
};
exports.replaceContent = replaceContent;
/** @deprecated use `@genoa/screen-content` for this utility and screen-content */
var deepReplaceContent = function (inputRecord, replacements) {
    return Object.entries(inputRecord).reduce(function (acc, _a) {
        var _b, _c, _d;
        var key = _a[0], value = _a[1];
        if (typeof value === 'string') {
            return __assign(__assign({}, acc), (_b = {}, _b[key] = (0, exports.replaceContent)(value, replacements), _b));
        }
        if (Array.isArray(value)) {
            return __assign(__assign({}, acc), (_c = {}, _c[key] = value.map(function (innerValue) {
                if (typeof innerValue === 'string') {
                    return (0, exports.replaceContent)(innerValue, replacements);
                }
                return (0, exports.deepReplaceContent)(innerValue, replacements);
            }), _c));
        }
        return __assign(__assign({}, acc), (_d = {}, _d[key] = (0, exports.deepReplaceContent)(value, replacements), _d));
    }, {});
};
exports.deepReplaceContent = deepReplaceContent;
